import React from 'react';

function NotFoundComponent() {
  return (
    <section className="container flex-start text-center flex-column container-notfound">
      <h1 className="mt-5 ">Not Found</h1>
      <h3 className="mg-3">404</h3>
    </section>
  );
}

export default NotFoundComponent;
